export enum FormatBase64 {
    CODE = 'code',
    DECODE = 'decode'
}

export const looperBase64 = (format: FormatBase64, payload: any, count: number = 0, limit: number = 7): any => {
    try {
        if (typeof payload !== 'string') {
            payload = JSON.stringify(payload);
        }

        if (count === limit) {
            return format === FormatBase64.CODE ? payload : JSON.parse(payload);
        }

        return count < limit && looperBase64(format, format === FormatBase64.CODE ? btoa(payload) : atob(payload), ++count);
    } catch (err) {
        return count < limit && looperBase64(format, format === FormatBase64.CODE ? btoa('{ }') : '{ }', ++count);
    }
}
